import React from 'react';

import { FormattedMessage } from 'react-intl';

import { fg } from '@atlaskit/platform-feature-flags/fg';

import { ProductKeys } from '../../../common/constants/product-keys';
import type { ThirdPartyConfigsBootstrap } from '../../../common/constants/schemas/3p-config';
import { OAuthBanner } from '../../../common/ui/oauth-banner';
import {
	getSlackAuthUpgradeBanner,
	shouldShowSlackAuthUpgradeBanner,
	SLACK_AUTH_UPGRADE_DISMISS_KEY,
} from '../../../common/utils/oauth-container/slack-auth-upgrade-banner';
import { slackEnterpriseGridAuthUpgradeMessages } from '../../../common/utils/oauth-container/slack-auth-upgrade-banner-messages';
import { useAnalytics } from '../../../controllers/analytics';
import { useOAuthHandlers } from '../../../controllers/oauth';

type ProductOauthUpgradeBannerProps = {
	selectedProduct: ProductKeys | undefined;
	thirdPartyConfigs: ThirdPartyConfigsBootstrap;
};

export const ProductOauthUpgradeBanner = ({
	selectedProduct,
	thirdPartyConfigs,
}: ProductOauthUpgradeBannerProps): React.JSX.Element | null => {
	const { fireAnalyticsEvent } = useAnalytics();
	const slackAuthUpgradeBanner = getSlackAuthUpgradeBanner(thirdPartyConfigs);

	if (
		selectedProduct !== ProductKeys.Slack ||
		!fg('ai_3p_slack_enterprise_grid_setup_enabled') ||
		!slackAuthUpgradeBanner ||
		!shouldShowSlackAuthUpgradeBanner()
	) {
		return null;
	}

	return (
		<OAuthBanner
			product={ProductKeys.Slack}
			outboundAuthUrl={slackAuthUpgradeBanner.outboundAuthUrl}
			useOAuthHandlers={useOAuthHandlers}
			isSmartlink={false}
			fireAnalyticsEvent={fireAnalyticsEvent}
			thirdPartyConfigs={thirdPartyConfigs}
			title={<FormattedMessage {...slackEnterpriseGridAuthUpgradeMessages.title} />}
			description={<FormattedMessage {...slackEnterpriseGridAuthUpgradeMessages.description} />}
			connectText={<FormattedMessage {...slackEnterpriseGridAuthUpgradeMessages.connectText} />}
			dismissCountKey={SLACK_AUTH_UPGRADE_DISMISS_KEY}
			extraAttributes={slackAuthUpgradeBanner.extraAttributes}
		/>
	);
};
